import {
  AdapterDateFns,
  ThemeProvider,
  LocalizationProvider,
} from 'components/base';
import { DesktopTimePicker } from '@mui/x-date-pickers/DesktopTimePicker';
import { theme } from './theme';
import { useStyle } from './style';

interface BasicTimePickerProps {
  name?: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
  disabled?: boolean;
  placeholder?: string;
  size?: string;
  inputStyle?: React.CSSProperties;
  timeIntervals?: number;
  error?: boolean;
  [key: string]: unknown;
}

/**
 * @deprecated Use TimePicker from atoms/TimePicker instead
 */
export default function BasicTimePicker({
  value,
  onChange,
  disabled,
  placeholder,
  size,
  inputStyle,
  timeIntervals = 15,
  error = false,
  ...rest
}: BasicTimePickerProps) {
  const classes = useStyle({
    size,
  })();
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DesktopTimePicker
          onChange={onChange}
          className={classes.root}
          value={value}
          disabled={disabled}
          minutesStep={timeIntervals}
          skipDisabled
          sx={{
            color: '#1976d2  !important',
            '& .MuiPickersInputBase': {
              borderColor: '#1976d2  !important',
              borderWidth: 2,
            },
          }}
          slotProps={{
            textField: {
              placeholder,
              fullWidth: true,
              size: 'small',
              error: !!error,

              style: inputStyle,
            },
            openPickerButton: { disableRipple: true },
          }}
          {...rest}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
}
